import { addScript } from '@tunein/web-utils';
import { noop } from 'es-toolkit';
import { appSessionDataProvider } from '../../providers';
import { api } from '../../singletons';
const PAL_SCRIPT = '//imasdk.googleapis.com/pal/sdkloader/pal.js';
const DISCORD_PAL_SCRIPT = '/googleapis/imasdk/pal/sdkloader/pal.js';
const requestOptions = {
    adWillAutoPlay: true,
    adWillPlayMuted: false,
    continuousPlayback: true,
    descriptionUrl: 'https%3A%2F%2Ftunein.com',
    iconsSupported: false,
    playerType: 'web',
    playerVersion: '3.0', // IMA SDK Version
    // this is a fix for a bug in the PAL SDK. This is undocumented @ https://developers.google.com/ad-manager/pal/html5,
    // but in the current version of the PAL SDK (as of 10/17/2023), it is unsafely checking for requestOptions.adTypes.length.
    // By setting adTypes as an empty array here, we are bypassing this unsafe access of the length property.
    adTypes: [],
};
export class GooglePalSdk {
    #isReady = false;
    #readyPromise;
    #nonceLoader;
    #nonceManager;
    constructor() {
        if (!api.isPremium) {
            this.#init();
        }
    }
    async #init() {
        if (this.#readyPromise) {
            await this.#readyPromise;
            return;
        }
        const { promise, resolve } = Promise.withResolvers();
        this.#readyPromise = promise;
        const src = appSessionDataProvider.isInDiscordIframe
            ? DISCORD_PAL_SCRIPT
            : PAL_SCRIPT;
        await addScript({ src }).catch(noop);
        try {
            this.#nonceLoader = new goog.pal.NonceLoader();
        }
        catch {
            // noop
        }
        resolve();
        this.#isReady = true;
    }
    #sendReport(type) {
        try {
            this.#nonceManager?.[type]?.();
        }
        catch (error) {
            api.logError('google.pal.reporting.error', { error }, false);
        }
    }
    async getNonce() {
        if (!this.#isReady) {
            await this.#init();
        }
        try {
            const nonceRequest = new goog.pal.NonceRequest();
            const { ppid } = api.adsTargeting ?? {};
            if (ppid) {
                nonceRequest.ppid = ppid;
            }
            Object.assign(nonceRequest, requestOptions);
            this.#nonceManager =
                await this.#nonceLoader.loadNonceManager(nonceRequest);
            if (this.#nonceManager) {
                return this.#nonceManager.getNonce();
            }
        }
        catch (error) {
            api.logError('google.pal.nonce.generator.error', { error }, false);
        }
        return '';
    }
    reportAdImpression() {
        this.#sendReport('sendAdImpression');
    }
    reportAdClick() {
        this.#sendReport('sendAdClick');
    }
}
